import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const BackLink = ({ to, label, testId }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      className="text-xs text-zinc-600 hover:text-zinc-950 flex items-center gap-1 mb-3 rounded transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-offset-1"
      data-testid={testId}
    >
      <ArrowLeft className="h-3.5 w-3.5" /> {label}
    </button>
  );
};
